"use strict";

import loadScript from '@elements/load-script';

export function init () {

    // let $manufacturerTab = $('.js-manufacturer-tab');
    // $manufacturerTab.addClass('show');

    loadScript("https://www.nexmart.com/api/dataview/assets/iframeResizer.min.js").then(() => {
        loadScript("https://www.nexmart.com/api/dataview/assets/dataview.loader.min.js").then(() => {

            let $nexmartContainer = $('.js-nexmart-container');
            let $manufacturerTab = $('.js-manufacturer-tab');

            $nexmartContainer.dataview({
                debug: false,
                errorCallback: function(error){
                    // Diese Funktion wird aufgerufen, wenn ein Fehler eufgetreten ist
                    console.log('Nexmart Error Callback', error);

                    if(!$manufacturerTab.hasClass('loadbee')){
                        $manufacturerTab.removeClass('show');
                    }

                    $nexmartContainer.addClass('d-none');


                    // Load loadbee
                    window.loadbeeCallback = function(loadbeeResponse){
                        $manufacturerTab.addClass('show');
                        return true;
                    }
                    var script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.async = true;
                    script.src = 'https://cdn.loadbee.com/js/loadbee_integration.js';
                    document.body.appendChild(script);
                },
                loadCallback: function(){
                    // Diese Funktion wird aufgerufen, wenn data View geladen ist
                    $manufacturerTab.addClass('show');
                }
            });

        }).catch(console.error);
    }).catch(console.error);

}
